import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { ColorTokens } from '@vds-tokens/color';
var RedText = /*#__PURE__*/styled.span.withConfig({
  displayName: "RedText",
  componentId: "VDS__sc-p8psq1-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  color: ", ";\n"])), ColorTokens.palette.red.value);
export default RedText;